export default __webpack_public_path__ + "static/media/people-plus-icon.f07b37e0.svg";